import Dialog from '@/components/Dialog';
import Button from '@/components/Button';
import Pagination from '@/components/Pagination';
import { useImportStaff } from '../../hooks/useImportStaff';
import { useManageStaffStore } from '../../store/useManageStaffStore';

export interface RowData {
  surname: string;
  forename: string;
  email: string;
}

export const ImportDialog = ({
  open,
  setOpen,
  refetch,
}: {
  open?: boolean;
  setOpen: React.Dispatch<boolean>;
  refetch: () => void;
}) => {
  const dialogData = useManageStaffStore((state) => state?.page?.staffImportFromSpreadsheetDialog);
  const {
    fileInput,
    handleFileUpload,
    handleImportStaff,
    handlePageChange,
    isLoading,
    loadingImport,
    paginatedData,
    currentPage,
    spreadsheetUploaded,
    totalPages,
  } = useImportStaff({ refetch, setOpen, rowsPerPage: 10 });

  return (
    <>
      <input type="file" accept=".xlsx,.xls,.csv" ref={fileInput} onChange={handleFileUpload} className="mb-4 hidden" />
      <Dialog
        open={open}
        setOpen={setOpen}
        title={dialogData?.title || ''}
        body={
          <>
            <p className="mb-4 text-left text-sh-16-24">{dialogData?.description || ''}</p>
            <table className="w-full table-auto">
              <thead>
                <tr>
                  <th className="border border-primary-300 bg-white px-4 py-2 text-left">Surname</th>
                  <th className="border border-primary-300 bg-white px-4 py-2 text-left">Forename</th>
                  <th className="border border-primary-300 bg-white px-4 py-2 text-left">Email</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, index) => (
                  <tr key={index}>
                    <td className="border px-4 py-2 text-left">{row.surname}</td>
                    <td className="border px-4 py-2 text-left">{row.forename}</td>
                    <td className="border px-4 py-2 text-left">{row.email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                pageSize={totalPages}
                onChangePage={(page: number) => {
                  handlePageChange(page);
                }}
              />
            )}
            <div className="flex justify-end gap-4">
              <Button
                theme="solid"
                className="mt-5"
                onClick={() => fileInput.current?.click()}
                loading={isLoading}
                disabled={loadingImport}>
                {dialogData?.uploadFileButtonText || ''}
              </Button>
              <Button
                theme="solid"
                className="mr-auto mt-5"
                onClick={() => handleImportStaff()}
                loading={isLoading || loadingImport}
                disabled={!spreadsheetUploaded || loadingImport}>
                {dialogData?.importStaffButtonText || ''}
              </Button>
              <Button theme="outline" className="mt-5" disabled={loadingImport} onClick={() => setOpen(false)}>
                {dialogData?.closeButtonText || ''}
              </Button>
            </div>
          </>
        }
      />
    </>
  );
};
